export const isHtml5StorageSupported = () => {
  try {
    return 'localStorage' in window && window['localStorage'] !== null;
  } catch (e) {
    return false;
  }
};

export const getGamesFromStorage = (key: string) => {
  try {
    const data = localStorage.getItem(key);

    if (!data) return [];

    const { games = [], timestamp = '' } = data ? JSON.parse(data) : {};

    const currentTimestamp = Date.now();
    const cacheExpirationTimestamp = Number(timestamp);

    if (cacheExpirationTimestamp <= currentTimestamp) {
      localStorage.removeItem(key);
      return [];
    }

    return games;
  } catch (e) {
    return [];
  }
};
